import React, { useState, useEffect } from 'react';
import './Portfolio.css';

export default function About() {
    const [work, setWork] = useState([]);
    const [activeTab, setActiveTab] = useState('All');
    const [searchWork, setSearchWork] = useState("");

    useEffect(() => {
        fetch('/portfolio.json')
            .then(response => response.json())
            .then(data => setWork(data))
            .catch(error => console.error('Error fetching data:', error));
    }, []);

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
        setSearchWork(tabName === 'All' ? "" : tabName.toLowerCase());
    };

    const filteredWork = work.filter(item =>
        searchWork === "" || item.type.toLowerCase() === searchWork
    );

    return (
        <div className='portfolio-container'>
            <div className="content">
                <h3>Portfolio</h3>
                <div className='golden-bar'></div>
                <div className="portfolio-container-bottom">
                    <div>
                        <ul className="navs">
                            <li
                                onClick={() => handleTabClick('All')}
                                style={{
                                    color: activeTab === 'All' ? '#FFCA66' : '#CFCFCF',
                                    textDecoration: 'none',
                                    cursor: 'pointer'
                                }}
                            >
                                All
                            </li>
                            <li
                                onClick={() => handleTabClick('Web development')}
                                style={{
                                    color: activeTab === 'Web development' ? '#FFCA66' : '#CFCFCF',
                                    textDecoration: 'none',
                                    cursor: 'pointer'
                                }}
                            >
                                Web development
                            </li>
                            <li
                                onClick={() => handleTabClick('Web design')}
                                style={{
                                    color: activeTab === 'Web design' ? '#FFCA66' : '#CFCFCF',
                                    textDecoration: 'none',
                                    cursor: 'pointer'
                                }}
                            >
                                Web design
                            </li>
                        </ul>
                    </div>
                    <div className="work-cards">
                        {filteredWork.map(item => (
                            <div key={item.id || item.title} className="work-card">
                                <img src={item.img} alt={item.title} />
                                <div className="work-desc">
                                    <p className="work-title">{item.title}</p>
                                    <p className="work-type">{item.type}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
